import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function WhatsAppFAB() {
    return (
        <a
            href="https://wa.me/918147813339"
            target="_blank"
            rel="noreferrer"
            className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-primary text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-fab-button"
        >
            <MessageCircle className="h-6 w-6" />
        </a>
    );
}
